<template>
  <div
    class="
      min-height
      user-list-main-wrapper
      cbg-white-container
      theme--light
      v-card
      user-list-wrap-box
    "
  >
    <CCol sm="12" class="pt-0">
      <div>
        <v-tabs
          v-model="tabs"
          background-color="transparent"
          class="border-bottom"
        >
          <v-tab
            v-for="(item, i) in items"
            :key="i"
            @change="changeTab(item)"
            >{{ item.tabName }}</v-tab
          >
        </v-tabs>

        <v-tabs-items v-model="tabs">
          <!-- .......... Doctor......... -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div v-if="tabs === 0">
                  <subscription-plans-listing
                    :role="'doctor'"
                  ></subscription-plans-listing>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- .......... Pharmacy......... -->

          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div v-if="tabs === 1">
                  <subscription-plans-listing
                    :role="'pharmacy'"
                  ></subscription-plans-listing>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- .......... Diagnostics ......... -->

          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div v-if="tabs === 2">
                  <subscription-plans-listing
                    :role="'diagnostics-lab'"
                  ></subscription-plans-listing>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- .......... Bloodbank ......... -->

          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div v-if="tabs === 3">
                  <subscription-plans-listing
                    :role="'bloodbank'"
                  ></subscription-plans-listing>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- .......... Ambulance ......... -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div v-if="tabs === 4">
                  <subscription-plans-listing
                    :role="'ambulance'"
                  ></subscription-plans-listing>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- .......... Allied ......... -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div v-if="tabs === 5">
                  <subscription-plans-listing
                    :role="'allied'"
                  ></subscription-plans-listing>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </CCol>
  </div>
</template> 
<script>
import { pickSvg } from "@/views/SVG";
// /Users/relife/Documents/git/admin-frontend-new/src/components/subscriptions/subscriptionReportsListTable.vue
const subscriptionPlansListing = () =>
  import("@/components/subscriptions/subscriptionPlansListing.vue");
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
export default {
  props: {},
  data() {
    return {
      dayJS,
      joinOnDateRange: { start: "", end: "" },
      tabs: null,
      items: [
        { tabName: "doctor" },
        { tabName: "pharmacy" },
        { tabName: "diagnostics-lab" },
        { tabName: "bloodbank" },
        { tabName: "ambulance" },
        { tabName: "allied" }
      ],
      role: "doctor",
    };
  },

  components: {
    ...pickSvg(
      "verticalDotsSVG",
      "nonverifiedUserSVG",
      "verifiedUserSVG",
      "searchSVG",
      "crossSVG"
    ),

    "subscription-plans-listing": subscriptionPlansListing,
  },
  methods: {
    changeTab(tab) {
      this.role = tab.tabName;
      this.joinOnDateRange = { start: "", end: "" };
    },
    removeDate() {
      this.joinOnDateRange = { start: "", end: "" };
    },
  },
  created() {},
};
</script>
<style lang="scss">
.capitalize-text {
  text-transform: capitalize;
}

.profilebox svg {
  width: 15px !important;
}
</style>
